export default __webpack_public_path__ + "static/media/E4D.6b63c752.mp3";